var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop","type":"button","aria-label":"Kembali ke atas","title":"Kembali ke atas"}},[_c('svg',{staticClass:"scrolltop__icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M5 15.5 12 8l7 7.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }